import { AmountContainer } from "./components/amount/amount.container";
import { DeliveryTypes } from "./components/deliveryTypes/deliveryTypes";
import { NoDelivery } from "./components/noDelivery/noDelivery.component";
import { OnlyAvailableInStore } from "./components/onlyAvailableInStore/onlyAvailableInStore.component";
import { ProductConfiguration } from "./components/productConfiguration/productConfiguration.container";
import { DeliveryBase } from "./delivery.base";

export const Delivery = Object.assign(DeliveryBase, {
    NoDelivery: NoDelivery,
    OnlyAvailableInStore: OnlyAvailableInStore,
    Types: DeliveryTypes,
    ProductConfiguration: ProductConfiguration,
    Amount: AmountContainer
});
